/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ServiceRouteImport } from './routes/service'
import { Route as PartsRouteImport } from './routes/parts'
import { Route as OfferRouteImport } from './routes/offer'
import { Route as NetworkRouteImport } from './routes/network'
import { Route as LoginRouteImport } from './routes/login'
import { Route as InviteRouteImport } from './routes/invite'
import { Route as ForgotRouteImport } from './routes/forgot'
import { Route as FleetRouteImport } from './routes/fleet'
import { Route as FindRouteImport } from './routes/find'
import { Route as FieldRouteImport } from './routes/field'
import { Route as ConfigureRouteImport } from './routes/configure'
import { Route as CatalogRouteImport } from './routes/catalog'
import { Route as CartRouteImport } from './routes/cart'
import { Route as IndexRouteImport } from './routes/index'

const ServiceRoute = ServiceRouteImport.update({
  id: '/service',
  path: '/service',
  getParentRoute: () => rootRouteImport,
} as any)
const PartsRoute = PartsRouteImport.update({
  id: '/parts',
  path: '/parts',
  getParentRoute: () => rootRouteImport,
} as any)
const OfferRoute = OfferRouteImport.update({
  id: '/offer',
  path: '/offer',
  getParentRoute: () => rootRouteImport,
} as any)
const NetworkRoute = NetworkRouteImport.update({
  id: '/network',
  path: '/network',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const InviteRoute = InviteRouteImport.update({
  id: '/invite',
  path: '/invite',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotRoute = ForgotRouteImport.update({
  id: '/forgot',
  path: '/forgot',
  getParentRoute: () => rootRouteImport,
} as any)
const FleetRoute = FleetRouteImport.update({
  id: '/fleet',
  path: '/fleet',
  getParentRoute: () => rootRouteImport,
} as any)
const FindRoute = FindRouteImport.update({
  id: '/find',
  path: '/find',
  getParentRoute: () => rootRouteImport,
} as any)
const FieldRoute = FieldRouteImport.update({
  id: '/field',
  path: '/field',
  getParentRoute: () => rootRouteImport,
} as any)
const ConfigureRoute = ConfigureRouteImport.update({
  id: '/configure',
  path: '/configure',
  getParentRoute: () => rootRouteImport,
} as any)
const CatalogRoute = CatalogRouteImport.update({
  id: '/catalog',
  path: '/catalog',
  getParentRoute: () => rootRouteImport,
} as any)
const CartRoute = CartRouteImport.update({
  id: '/cart',
  path: '/cart',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/cart': typeof CartRoute
  '/catalog': typeof CatalogRoute
  '/configure': typeof ConfigureRoute
  '/field': typeof FieldRoute
  '/find': typeof FindRoute
  '/fleet': typeof FleetRoute
  '/forgot': typeof ForgotRoute
  '/invite': typeof InviteRoute
  '/login': typeof LoginRoute
  '/network': typeof NetworkRoute
  '/offer': typeof OfferRoute
  '/parts': typeof PartsRoute
  '/service': typeof ServiceRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/cart': typeof CartRoute
  '/catalog': typeof CatalogRoute
  '/configure': typeof ConfigureRoute
  '/field': typeof FieldRoute
  '/find': typeof FindRoute
  '/fleet': typeof FleetRoute
  '/forgot': typeof ForgotRoute
  '/invite': typeof InviteRoute
  '/login': typeof LoginRoute
  '/network': typeof NetworkRoute
  '/offer': typeof OfferRoute
  '/parts': typeof PartsRoute
  '/service': typeof ServiceRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/cart': typeof CartRoute
  '/catalog': typeof CatalogRoute
  '/configure': typeof ConfigureRoute
  '/field': typeof FieldRoute
  '/find': typeof FindRoute
  '/fleet': typeof FleetRoute
  '/forgot': typeof ForgotRoute
  '/invite': typeof InviteRoute
  '/login': typeof LoginRoute
  '/network': typeof NetworkRoute
  '/offer': typeof OfferRoute
  '/parts': typeof PartsRoute
  '/service': typeof ServiceRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/cart'
    | '/catalog'
    | '/configure'
    | '/field'
    | '/find'
    | '/fleet'
    | '/forgot'
    | '/invite'
    | '/login'
    | '/network'
    | '/offer'
    | '/parts'
    | '/service'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/cart'
    | '/catalog'
    | '/configure'
    | '/field'
    | '/find'
    | '/fleet'
    | '/forgot'
    | '/invite'
    | '/login'
    | '/network'
    | '/offer'
    | '/parts'
    | '/service'
  id:
    | '__root__'
    | '/'
    | '/cart'
    | '/catalog'
    | '/configure'
    | '/field'
    | '/find'
    | '/fleet'
    | '/forgot'
    | '/invite'
    | '/login'
    | '/network'
    | '/offer'
    | '/parts'
    | '/service'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  CartRoute: typeof CartRoute
  CatalogRoute: typeof CatalogRoute
  ConfigureRoute: typeof ConfigureRoute
  FieldRoute: typeof FieldRoute
  FindRoute: typeof FindRoute
  FleetRoute: typeof FleetRoute
  ForgotRoute: typeof ForgotRoute
  InviteRoute: typeof InviteRoute
  LoginRoute: typeof LoginRoute
  NetworkRoute: typeof NetworkRoute
  OfferRoute: typeof OfferRoute
  PartsRoute: typeof PartsRoute
  ServiceRoute: typeof ServiceRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/service': {
      id: '/service'
      path: '/service'
      fullPath: '/service'
      preLoaderRoute: typeof ServiceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/parts': {
      id: '/parts'
      path: '/parts'
      fullPath: '/parts'
      preLoaderRoute: typeof PartsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/offer': {
      id: '/offer'
      path: '/offer'
      fullPath: '/offer'
      preLoaderRoute: typeof OfferRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/network': {
      id: '/network'
      path: '/network'
      fullPath: '/network'
      preLoaderRoute: typeof NetworkRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invite': {
      id: '/invite'
      path: '/invite'
      fullPath: '/invite'
      preLoaderRoute: typeof InviteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot': {
      id: '/forgot'
      path: '/forgot'
      fullPath: '/forgot'
      preLoaderRoute: typeof ForgotRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/fleet': {
      id: '/fleet'
      path: '/fleet'
      fullPath: '/fleet'
      preLoaderRoute: typeof FleetRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/find': {
      id: '/find'
      path: '/find'
      fullPath: '/find'
      preLoaderRoute: typeof FindRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/field': {
      id: '/field'
      path: '/field'
      fullPath: '/field'
      preLoaderRoute: typeof FieldRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/configure': {
      id: '/configure'
      path: '/configure'
      fullPath: '/configure'
      preLoaderRoute: typeof ConfigureRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/catalog': {
      id: '/catalog'
      path: '/catalog'
      fullPath: '/catalog'
      preLoaderRoute: typeof CatalogRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cart': {
      id: '/cart'
      path: '/cart'
      fullPath: '/cart'
      preLoaderRoute: typeof CartRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  CartRoute: CartRoute,
  CatalogRoute: CatalogRoute,
  ConfigureRoute: ConfigureRoute,
  FieldRoute: FieldRoute,
  FindRoute: FindRoute,
  FleetRoute: FleetRoute,
  ForgotRoute: ForgotRoute,
  InviteRoute: InviteRoute,
  LoginRoute: LoginRoute,
  NetworkRoute: NetworkRoute,
  OfferRoute: OfferRoute,
  PartsRoute: PartsRoute,
  ServiceRoute: ServiceRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
